export default "__VITE_ASSET__BEg5hbZP__"